import { Outlet } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { AdminBanner } from './components/AdminBanner';
// Cycle 44 — LangFeedbackToast root mount (모든 page 에서 Alt+L lang toggle feedback)
import { LangFeedbackToast } from './components/LangFeedbackToast';
// Cycle 45 — ErrorBoundary — React component error 시 graceful fallback
import { ErrorBoundary } from './components/ErrorBoundary';
// 공통 레이어팝업(경고/컨펌) root mount — window.confirm/alert 대체.
import { LayerPopupHost } from './components/LayerPopup/LayerPopup';
// 조직도 내부 팝업 root mount — 좌측 레일 "조직도" 가 페이지 이동 대신 이걸 연다.
import { OrgDirectoryHost } from './components/OrgDirectoryModal';

export function App() {
  return (
    <AppLayout>
      {/* FE-W-11 — 회사 가입 24h grace 안내. ADMIN + graceUntil 있을 때만 표시. */}
      <AdminBanner />
      {/* Cycle 45 — ErrorBoundary Outlet 만 wrap. AdminBanner/LangFeedbackToast 는 stable 가정. */}
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
      {/* Cycle 44 — LangFeedbackToast root mount. AdminConsolePage 의 inline 제거됨.
          모든 page 에서 setSharedLang 호출 시 자동 toast 표시. */}
      <LangFeedbackToast />
      <LayerPopupHost />
      <OrgDirectoryHost />
    </AppLayout>
  );
}

export default App;
